const isSupportedLabelCodePoint = (codePoint) => {
  if (codePoint === 0x09 || codePoint === 0x0a || codePoint === 0x0d) {
    return true;
  }

  if (codePoint >= 0x20 && codePoint <= 0x7e) {
    return true;
  }

  return false;
};

export const findUnsupportedCharacters = (value) => {
  if (!value) {
    return [];
  }

  if (typeof value !== 'string') {
    return [];
  }

  return [...value].reduce((accumulator, char, index) => {
    const codePoint = char.codePointAt(0);

    if (codePoint === undefined) {
      return accumulator;
    }

    if (!isSupportedLabelCodePoint(codePoint)) {
      accumulator.push({ index, value: char, codePoint });
    }

    return accumulator;
  }, []);
};

export const hasUnsupportedCharacters = (value) => {
  return findUnsupportedCharacters(value).length > 0;
};

export const validateASCIIChars =
  (errorMessage = 'Contains unsupported characters') =>
  (value) => {
    return !value || !hasUnsupportedCharacters(value) ? undefined : errorMessage;
  };
